export default {
  'response.responseDefinitionWasDeleted':
    'The response definition was deleted, please try another one',
  'response.responseIsNotJson': 'The format of the response data is not JSON',
  'response.responseIsNotMsgpack': 'The format of the response data is not Msgpack',
  'response.responseIsNotNoContent': 'This response should not have a body',
  'response.resultResponseWithDetail': 'returned {response}, expected {responseDefinition}.',
  'response.responseSizeThreshold': 'if data size larger than 50MB, the response will not be shown',
  'response.imageContentType': 'Image: {type}',
  'response.fileContentType': 'File: {type}',
  'response.pdfContentType': 'PDF: {type}',
  'response.videoContentType': 'Video: {type}',
  'response.tooManyCharacters': 'For performance reasons, the response content is not formatted.',
  'response.saveAsFile': 'Save as a file',
};
